import { X, MessageSquare, Download, Tag } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAnalyticsStore } from '../../stores/analyticsStore';

interface BulkActionsBarProps {
  selectedCount: number;
}

export function BulkActionsBar({ selectedCount }: BulkActionsBarProps) {
  const { clearPatientSelection } = useAnalyticsStore();

  const handleStartOutreach = () => {
    console.log('Start outreach campaign');
  };

  const handleExport = () => {
    console.log('Export selected patients');
  };

  const handleAddToList = () => {
    console.log('Add to list');
  };

  if (selectedCount === 0) return null;

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 w-[calc(100%-2rem)] sm:w-auto">
      <div className="flex flex-wrap items-center justify-center gap-2 px-4 py-2 bg-primary text-primary-foreground rounded-lg shadow-lg">
        <span className="text-sm font-medium">
          {selectedCount} patient{selectedCount !== 1 ? 's' : ''} selected
        </span>

        <div className="h-4 w-px bg-primary-foreground/30 mx-2" />

        <Button
          variant="secondary"
          size="sm"
          onClick={handleStartOutreach}
          className="bg-primary-foreground/10 hover:bg-primary-foreground/20 text-primary-foreground"
        >
          <MessageSquare className="h-4 w-4 mr-2" />
          Start Outreach
        </Button>

        <Button
          variant="secondary"
          size="sm"
          onClick={handleExport}
          className="bg-primary-foreground/10 hover:bg-primary-foreground/20 text-primary-foreground"
        >
          <Download className="h-4 w-4 mr-2" />
          Export
        </Button>

        <Button
          variant="secondary"
          size="sm"
          onClick={handleAddToList}
          className="bg-primary-foreground/10 hover:bg-primary-foreground/20 text-primary-foreground"
        >
          <Tag className="h-4 w-4 mr-2" />
          Add to List
        </Button>

        <div className="h-4 w-px bg-primary-foreground/30 mx-2" />

        <Button
          variant="ghost"
          size="icon"
          onClick={clearPatientSelection}
          className="h-8 w-8 text-primary-foreground hover:bg-primary-foreground/20"
        >
          <X className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
